import React, { ReactNode } from "react";

// The word joiner keeps the asterisk with the last word when a label wraps.
export default function RequiredLabel({ children }: { children: ReactNode }) {
  return (
    <>
      {children}
      <span className="customize-tour-form__required">{"⁠*"}</span>
    </>
  );
}
